var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrowel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13977 14.5422L2.07094 3.49826C1.74311 2.60843 2.60843 1.74311 3.49826 2.07094L14.5422 6.13977C15.3034 6.42021 15.5176 7.3952 14.944 7.96882L12.0459 10.8669L15.1899 14.0109L15.3864 13.8144C15.8205 13.3803 16.5243 13.3803 16.9584 13.8144L21.6744 18.5304C22.1085 18.9645 22.1085 19.6683 21.6744 20.1024L20.1024 21.6744C19.6683 22.1085 18.9645 22.1085 18.5304 21.6744L13.8144 16.9584C13.3803 16.5243 13.3803 15.8205 13.8144 15.3864L14.0109 15.1899L10.8669 12.0459L7.96881 14.944C7.3952 15.5176 6.42021 15.3034 6.13977 14.5422Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrowel);
export default __webpack_public_path__ + "static/media/trowel.78c797051d11c9873e3bb0407d87b1bd.svg";
export { ForwardRef as ReactComponent };